module.exports = __webpack_public_path__ + "img/map_transparent_bg.6140c7.png";